import { Warning } from '@phosphor-icons/react';
import { DarkPopup } from '@elements/Popup';
import { AddressValidationContainer } from './styles';

export function InvalidAddress({
  onClick,
  addressValidationData,
  addressValidationError,
}) {
  return (
    <DarkPopup
      trigger={
        <AddressValidationContainer onClick={onClick}>
          <Warning className="sk:mr-1!" size={14} />
          <span>Validate Address</span>
        </AddressValidationContainer>
      }
      position="top left"
      disabled={
        !addressValidationData?.error &&
        !addressValidationData?.description &&
        !addressValidationError
      }
    >
      {addressValidationData?.error ||
        addressValidationData?.description ||
        addressValidationError}
    </DarkPopup>
  );
}
